import { Info, AlertTriangle } from "lucide-react";
import {
  Widget,
  WidgetHeader,
  WidgetContent,
} from "@/components/consultation/shared/Widget";

export interface RiskItem {
  label: string;
  score: number;
  severity: "High" | "Med" | "Low";
}

interface RiskAnalysisCardProps {
  riskAnalysis?: RiskItem[] | null;
}

const severityStyles = {
  High: "bg-destructive text-destructive-foreground",
  Med: "bg-warning text-warning-foreground",
  Low: "bg-primary text-primary-foreground",
} as const;

export const RiskAnalysisCard = ({ riskAnalysis }: RiskAnalysisCardProps) => {
  const hasRisks = !!riskAnalysis && riskAnalysis.length > 0;

  return (
    <Widget>
      <WidgetHeader title="Risk Analysis" hasInfo />
      <WidgetContent>
        {hasRisks ? (
          <div className="flex flex-wrap items-center gap-1.5">
            {riskAnalysis!.map((item) => (
              <RiskBadge key={item.label} item={item} />
            ))}
          </div>
        ) : (
          <div className="flex items-center gap-1.5">
            <AlertTriangle className="size-3.5 text-muted-foreground" />
            <span className="z-caption text-muted-foreground">No data yet</span>
          </div>
        )}
      </WidgetContent>
    </Widget>
  );
};

function RiskBadge({ item }: { item: RiskItem }) {
  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 z-caption ${severityStyles[item.severity]}`}
    >
      <Info className="size-3" />
      <span className="font-medium">{item.label}</span>
      <span className="z-numeric font-semibold">{item.score}</span>
      <span>{item.severity}</span>
    </div>
  );
}
